export { AzureConfigurator } from "./azureConfiguration";
export { useAzureConfig } from "./useAzureConfigHook";
